module.exports = __webpack_public_path__ + "static/media/warning_red.ba254da7.svg";